import {useTranslations} from 'next-intl';

export default function CatalogFilterButton() {
  const t = useTranslations('header');
  return (
      <div className="catalog-categories-menu-button">
        <a
            href="#ltn__utilize-mobile-categories"
            className="ltn__utilize-toggle"
        >
          <span className="cat-title">{t('catalog')}</span>
          <i className="icon-menu"></i>
        </a>
      </div>
  );
};
